import { useBack } from 'admin';
import { MaterialProductValueType } from 'api';
import { Form, useForm, yupResolver } from 'form';
import { Button, Grid } from 'ui';

import { useUpdateMaterialProduct } from '../../hooks/useUpdateMaterialProduct/useUpdateMaterialProduct';
import type { UpdateFormValues } from '../../pages/MaterialProductDetails/MaterialProductDetails';
import { MaterialProductSchema } from '../../pages/schema';
import { DeleteMaterialProductButton } from '../DeleteMaterialProductButton/DeleteMaterialProductButton';
import { MaterialProductFormSections } from '../MaterialProductFormSections/MaterialProductFormSections';

type Props = {
  materialProductId: number;
  materialProductData: UpdateFormValues | undefined;
};

export const MaterialProductUpdateForm = ({ materialProductId, materialProductData }: Props) => {
  const goBack = useBack();
  const form = useForm<UpdateFormValues>({
    resolver: yupResolver(MaterialProductSchema),
    values: materialProductData,
  });

  const { mutate: updateMaterialProduct, isPending: isUpdating } = useUpdateMaterialProduct(form);

  const onSubmit = async (values: UpdateFormValues) => {
    const sellerMaterialComponents = values.seller_material_component_values
      ? values.seller_material_component_values.map((materialComponent) => ({
          boolean_value: materialComponent.boolean_value,
          max_value: materialComponent.max_value ? materialComponent.max_value.toString() : undefined,
          min_value: materialComponent.min_value ? materialComponent.min_value.toString() : undefined,
          supported_component_id: materialComponent.supported_component_id,
          type: MaterialProductValueType.SELLER,
        }))
      : [];
    const buyerMaterialComponents = values.buyer_material_component_values
      ? values.buyer_material_component_values.map((materialComponent) => ({
          boolean_value: materialComponent.boolean_value,
          max_value: materialComponent.max_value ? materialComponent.max_value.toString() : undefined,
          min_value: materialComponent.min_value ? materialComponent.min_value.toString() : undefined,
          supported_component_id: materialComponent.supported_component_id,
          type: MaterialProductValueType.BUYER,
        }))
      : [];

    await updateMaterialProduct({
      data: { ...values, material_component_values: [...sellerMaterialComponents, ...buyerMaterialComponents] },
      id: materialProductId,
    });
  };

  return (
    <Form {...form} onSubmit={onSubmit}>
      <MaterialProductFormSections />
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Button loading={isUpdating} type="submit" fullWidth>
            Update
          </Button>
        </Grid>
        <Grid item xs={12} md={4}>
          <Button onClick={goBack} variant="secondary" fullWidth>
            Cancel
          </Button>
        </Grid>
        <Grid item xs={12} md={4}>
          <DeleteMaterialProductButton id={materialProductId} />
        </Grid>
      </Grid>
    </Form>
  );
};
